import { React, useEffect, useState } from "react";
import dataset from "../../../../../Datasets/metabric.csv";
import { DataGrid } from "@material-ui/data-grid";
import { csv } from "d3";
import { LinearProgress } from "@material-ui/core";

export default function BasicTable() {
  //const result = readString(dataset);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  let colArray = [];

  useEffect(() => {
    csv(dataset).then((d) => {
      d.forEach((row, index) => {
        row.id = index;
      });
      setRows(d);
      setTimeout(() => {
        setLoading(false);
      }, 2000);

      Object.keys(d[0]).forEach((title) => {
        colArray.push({ field: title, headerName: title, width: 150 });
      });
      setColumns(colArray);
    });
    return () => undefined;
  }, []);

  return (
    <div style={{ height: 400, width: "100%", overflow: "scroll" }}>
      {loading ? (
        <LinearProgress />
      ) : (
        <DataGrid rows={rows} columns={columns} pageSize={15} />
      )}
    </div>
  );
}
